import { CodeXml } from "lucide-react";

/**
 * The art panel for a project with no cover.
 *
 * A tinted panel carrying the title rather than a remote placeholder service:
 * the card still reads as part of the grid, and it costs no network request.
 */
export default function ProjectPlaceholder({
  title,
}: Readonly<{ title: string }>) {
  return (
    <div className="project-placeholder">
      <CodeXml aria-hidden="true" size={26} />
      <span>{title}</span>
    </div>
  );
}
